import {
  AutoComplete,
  Button,
  Drawer,
  Form,
  Input,
  Popconfirm,
  Select,
  Spin,
  Switch,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useParams, useHistory } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import {
  getPage,
  getParamValue,
  getUpdatedUrl,
  checkStatesAndPushToHistory,
} from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import {
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import Empty from "../common/Empty";
import { responseNotification } from "../../utils/notify";
import debounce from "lodash";
import AddArea from "./AddArea";
import usePrevious from "../../hooks/PreviousState";
const { Option } = Select;

const AreaList = ({
  inHub = false,
  activeSearch = true,
  addDrawer,
  refetch,
}: {
  inHub?: boolean;
  activeSearch?: boolean;
  addDrawer?: any;
  refetch?: boolean;
}) => {
  const history = useHistory();
  const router = useLocation();
  const [visible, setVisible] = useState(undefined);
  const [selectedArea, setselectedArea] = useState(undefined);
  const [selectedAreaForEdit, setSelectedAreaForEdit] = useState(undefined);

  const [name, setName] = useState(getParamValue(router.search, "name"));
  const [status, setStatus] = useState("");
  const [type, setType] = useState("JC_MART");
  const [limit, setLimit] = useState(16);
  const [isActive, setIsActive] = useState(
    getParamValue(router.search, "isActive") || ""
  );
  const [areaData, setAreaData] = useState({
    loading: false,
    data: null,
  });

  const [areaOptions, setAreaOptions] = useState({
    loading: false,
    list: null,
  });

  const [regionsOptions, setRegionsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [hubsOptions, setHubsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [hubId, setHubId] = useState<any>();
  const [regionId, setRegionId] = useState(
    getParamValue(router.search, "regionId")
  );
  const [confirmLoading, setConfirmLoading] = useState(false);

  const fetchRef = useRef(null);
  const route = useParams();
  const [form] = Form.useForm();
  // const loc = useLocation();
  const page = getParamValue(router.search, "page");

  const prevName = usePrevious(name);
  const prevRegionId = usePrevious(regionId);
  const prevIsActive = usePrevious(isActive);

  const reseAllFieldData = () => {
    setStatus("");
    setName("");
    setType("");
    form.resetFields();

    history.replace(router.pathname);
    window.location.reload();
  };

  window.onbeforeunload = () => {
    saveCurrentStatesInLocalStorage();
  };
  function checkLocalStorageAndSetParams() {
    var retrievedObject = JSON.parse(
      localStorage.getItem("rememberAreaFilter")
    );
    console.log("rememberAreaFilter: ", retrievedObject);
    if (retrievedObject.name) setName(retrievedObject.name);
    if (retrievedObject.regionId) setRegionId(retrievedObject.regionId);
    if (retrievedObject.isActive) setIsActive(retrievedObject.isActive);
    if (retrievedObject.page) {
      history.push(getUpdatedUrl("page", `${retrievedObject.page}`));
    }
  }
  const saveCurrentStatesInLocalStorage = () => {
    localStorage.setItem(
      "rememberAreaFilter",
      JSON.stringify({
        name: name,
        regionId: regionId,
        isActive: isActive,
        page: page,
      })
    );
  };

  const handleChangeStatus = (value: string) => {
    setStatus(value);
  };

  const getArea = useCallback(
    async (getHubId) => {
      let shouldResetPage = false;
      if (localStorage.getItem("rememberAreaFilter") != null) {
        checkLocalStorageAndSetParams();
        localStorage.removeItem("rememberAreaFilter");
      } else {
        shouldResetPage = checkStatesAndPushToHistory(
          [prevName, prevRegionId, prevIsActive],
          [name, regionId, isActive],
          ["name", "regionId", "isActive"],
          history
        );
      }
      setAreaData({ loading: true, data: null });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      if (inHub) {
        axios
          .get(
            `${encodedUri}/admin/area?` +
              `&page=${shouldResetPage ? 0 : page || 0}` +
              `&limit=${limit || 16}` +
              (name ? `&name=${name}` : ``) +
              (regionId ? `&regionId=${regionId}` : ``) +
              (getHubId ? `&hubId=${getHubId}` : ``) +
              (isActive != null && isActive !== ""
                ? `&isActive=${isActive}`
                : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          )
          .then((res) => {
            setAreaData({ loading: false, data: res.data });
          })
          .catch((err) => {
            setAreaData({ loading: false, data: [] });
            console.error("Area: Error", err);
          });
      } else {
        axios
          .get(
            `${encodedUri}/admin/area?` +
              `&page=${shouldResetPage ? 0 : page || 0}` +
              `&limit=${limit || 16}` +
              (name ? `&name=${name}` : ``) +
              (regionId ? `&regionId=${regionId}` : ``) +
              (hubId ? `&hubId=${hubId}` : ``) +
              (isActive != null && isActive !== ""
                ? `&isActive=${isActive}`
                : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          )
          .then((res) => {
            setAreaData({ loading: false, data: res.data });
          })
          .catch((err) => {
            setAreaData({ loading: false, data: [] });
            console.error("Area: Error", err);
          });
      }
    },
    [limit, page, name, regionId, hubId, isActive]
  );

  const getAreaOptions = useCallback(
    async (name) => {
      setAreaOptions({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      axios
        .get(
          `${encodedUri}/area?` +
            `page=${page || 0}` +
            `&limit=${limit || 16}` +
            (name ? `&name=${name}` : ``) +
            (inHub ? `&hubId=${(route as any).hubId}` : ``) +
            (isActive ? `&isActive=${isActive}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setAreaOptions({
            loading: false,
            list: res.data?.areas?.map((area: any) => ({
              label: area.name,
              value: area.name,
            })),
          });
        })
        .catch((err) => {
          setAreaOptions({ loading: false, list: [] });
          console.error("Categories: Error", err);
        });
    },
    [isActive]
  );

  //
  const onDelete = async (id) => {
    if (id) {
      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/area?areaId=${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: id,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Area Deleted Successfully", "success");
            setVisible(undefined);
            getArea((route as any).hubId);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  //
  const onStatusChange = async (id, val) => {
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/area`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            getArea(``);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };
  //

  const getRegionsOptions = useCallback(
    async (val?: string) => {
      setRegionsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/region?` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setRegionsOptions({
        loading: false,
        list: res?.data?.regions?.map((region: any) => {
          return {
            id: region?.id,
            name: region?.name,
          };
        }),
      });
    },
    [type]
  );

  const getHubsOptions = useCallback(
    async (val?: string) => {
      setHubsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/hub/search?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setHubsOptions({
        loading: false,
        list: res?.data?.hub?.map((hub: any) => {
          return {
            id: hub?.id,
            name: hub?.name,
          };
        }),
      });
    },
    [type]
  );

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "area") getAreaOptions(value);
        else if (field === "shop") getHubsOptions(value);
        // else if (field === "hub") getShopsOptions(value);
        else if (field === "region") getRegionsOptions(value);
      }
    };

    return debounce(loadOptions);
  }, [getAreaOptions, getRegionsOptions, getHubsOptions]);

  useEffect(() => {
    getArea((route as any).hubId);
  }, [getArea, refetch]);

  // useEffect(() => {
  //   if (inHub) getArea((route as any).hubId);
  // }, [getArea, inHub]);

  useEffect(() => {
    if (visible) {
      setselectedArea(undefined);
      setSelectedAreaForEdit(undefined);
    }
  }, [selectedArea, selectedAreaForEdit]);

  useEffect(() => {
    setselectedArea(undefined);
    setSelectedAreaForEdit(undefined);
  }, [visible]);

  useEffect(() => {
    if (activeSearch) {
      getHubsOptions("");
      getRegionsOptions("");
    }
  }, [getHubsOptions, getRegionsOptions, activeSearch]);

  const onClose = () => {
    setselectedArea(null);
    setSelectedAreaForEdit(null);
    getArea((route as any).hubId);
    getArea("");
    form.resetFields();
  };

  const showPopconfirm = (id) => {
    setVisible(id);
  };

  const handleCancel = () => {
    setVisible(undefined);
  };

  return (
    <React.Fragment>
      {!inHub && (
        <TopHeading {...areaData?.data?.totalElements} refetch={getArea} />
      )}

      {activeSearch && (
        <section className="search_area">
          <Form form={form} className="search_form">
            <Form.Item name="area" initialValue={name}>
              <AutoComplete
                onSearch={getAreaOptions}
                onSelect={(val) => setName(val.toString())}
                options={areaOptions?.list}
                defaultActiveFirstOption={false}
                notFoundContent={
                  areaOptions?.loading ? <Spin size="small" /> : null
                }
              >
                <Input.Search
                  size="large"
                  placeholder="Search by Name"
                  onSearch={(val) => {
                    setName(val);
                  }}
                  enterButton
                  loading={areaOptions.loading}
                  pattern={`[0-9]`}
                  maxLength={11}
                />
              </AutoComplete>
            </Form.Item>

            {!inHub && (
              <Form.Item name="hub">
                <Select
                  showSearch
                  placeholder="Select Hub"
                  optionFilterProp="children"
                  onChange={(val) => setHubId(val)}
                  onSearch={getHubsOptions}
                  filterOption={(input, option) =>
                    option.children
                      .toString()
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  allowClear
                >
                  {hubsOptions?.list?.map((hub: any) => (
                    <Option value={hub.id}>{hub.name}</Option>
                  ))}
                </Select>
              </Form.Item>
            )}

            <Form.Item name="region" initialValue={regionId}>
              <Select
                showSearch
                placeholder="Select Region"
                optionFilterProp="children"
                onChange={(val) => setRegionId(val)}
                onSearch={getRegionsOptions}
                filterOption={(input, option) =>
                  option.children
                    .toString()
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                allowClear
              >
                {regionsOptions?.list?.map((region: any) => (
                  <Option value={region.id}>{region.name}</Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="status_search"
              initialValue={
                isActive == "true"
                  ? "ACTIVE"
                  : isActive == "false"
                  ? "INACTIVE"
                  : "ALL"
              }
            >
              <Select
                showSearch
                placeholder="Status"
                onChange={(val) => setIsActive(val as string)}
              >
                <Select.Option value={null}>ALL</Select.Option>
                <Select.Option value={true}>ACTIVE</Select.Option>
                <Select.Option value={false}>INACTIVE</Select.Option>
              </Select>
            </Form.Item>
          </Form>

          <div className="search_btn">
            <Button
              type="primary"
              danger
              size="large"
              onClick={reseAllFieldData}
            >
              Reset
            </Button>
          </div>
        </section>
      )}
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Area Name</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Region</span>
                  </div>
                  {!inHub && (
                    <div className="single-product-heading">
                      <span>Hub</span>
                    </div>
                  )}
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {areaData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {areaData?.data?.areas?.length ? (
                    areaData?.data?.areas?.map((area: any, index: any) => (
                      <React.Fragment key={index}>
                        <div
                          className="single-product-wrapper"
                          // onClick={() => setselectedArea(area)}
                        >
                          <div className="single-product">
                            <span className="name">{area?.name}</span>
                          </div>{" "}
                          <div className="single-product">
                            <span className="name text-capitalize">
                              {area?.region?.name}
                            </span>
                          </div>
                          <div className="single-product">
                            <span className="name text-capitalize">
                              {area?.hub?.name}
                            </span>
                          </div>
                          <div className="single-product">
                            <span className="name">
                              {area?.type?.split("_").join(" ")}
                            </span>
                          </div>
                          <div className="single-product">
                            <Switch
                              checkedChildren={<CheckOutlined />}
                              unCheckedChildren={<CloseOutlined />}
                              defaultChecked={area?.isActive}
                              onChange={(val, e) => {
                                e.preventDefault();
                                onStatusChange(area?.id, val);
                              }}
                              title="Active/Inactive"
                            />
                          </div>
                          <div className="single-product">
                            {inHub ? (
                              <Popconfirm
                                placement="left"
                                title="Are you sure to Delete this Area Parmamently ?"
                                visible={area?.id === visible}
                                okButtonProps={{ loading: confirmLoading }}
                                onConfirm={() => onDelete(area?.id)}
                                onCancel={(e) => {
                                  e.preventDefault();
                                  handleCancel();
                                }}
                                disabled={area?.deleted}
                              >
                                <Button
                                  type="primary"
                                  danger
                                  className="btn btn-sm btn-danger mx-1"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    showPopconfirm(area?.id);
                                  }}
                                  disabled={area?.deleted}
                                  title="Remove From Hub"
                                >
                                  {/* <ApiOutlined /> */}
                                  <DeleteOutlined />
                                </Button>
                              </Popconfirm>
                            ) : (
                              <button
                                className="btn btn-sm btn-warning mx-1"
                                onClick={() => setSelectedAreaForEdit(area)}
                              >
                                <EditOutlined />
                              </button>
                            )}
                          </div>
                        </div>
                      </React.Fragment>
                    ))
                  ) : (
                    <Empty data="Area" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title={selectedAreaForEdit ? "Edit Area" : "Area Details"}
            width={selectedAreaForEdit ? 500 : 800}
            onClose={() => {
              setselectedArea(null);
              setSelectedAreaForEdit(null);
            }}
            visible={selectedArea || selectedAreaForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            <AddArea
              visibleData={selectedAreaForEdit}
              onCloseMethod={onClose}
            />
          </Drawer>

          <PaginationTwo
            {...areaData?.data}
            limit={limit}
            page={getPage(router.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default AreaList;
